// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c0609b6b","513":"9db425d6","787":"2bf8dbc1"}[chunkId] + ".chunk.js";
};